
const userinfo = "";
const screenwidth="300";
export default {
	screenwidth,
	userinfo,
	 getUserInfo() {
	  if (window.localStorage.uinfo)
	    return JSON.parse(window.localStorage.uinfo)[0];
	  return null;
	},
	 setUserInfo(userinfo) {
	  window.localStorage.uinfo = userinfo;
	}
}
